<template>
    <div>
        <tracker-new-data-header v-if="!editTarget" :columns="columns"></tracker-new-data-header>
        <div
            v-if="canTrackManually && Object.keys(preferenceAssessmentItems).length"
            class="row px-3 new-data-inputs"
        >
            <div class="col-2 px-1 py-3">
                <v-date-picker
                    dusk="date"
                    placeholder="MM/DD/YYYY"
                    id="date"
                    class="picker-container"
                    popover-align="left"
                    v-model="date"
                ></v-date-picker>
            </div>
            <template v-if="goal.parameters.method === 'paired'">
                <div class="col-9">
                    <div class="row" style="margin-top: -1.5rem;">
                        <div class="p-1 col-2 col-md-3 text-white text-uppercase small ellipsis">
                            Item
                        </div>
                        <div class="p-1 col-3 col-md-2 text-white text-uppercase small ellipsis">
                            Selected
                        </div>
                        <div class="p-1 col-3 col-md-2 text-white text-uppercase small ellipsis">
                            Presented
                        </div>
                        <div class="p-1 col-2 col-md-2 text-white text-uppercase small ellipsis">
                            Percent
                        </div>
                        <div class="p-1 col-2 col-md-3 text-white text-uppercase small">
                            Note
                        </div>
                    </div>
                    <div class="row" v-for="(t, i) in goal.parameters.items">
                        <div class="p-1 col-2 col-md-3 small">
                            {{ t }}
                        </div>
                        <div class="p-1 col-3 col-md-2">
                            <input
                                v-mask="'##'"
                                type="text"
                                v-model.number="preferenceAssessmentItems[t].selected"
                                name="selected"
                                class="form-control form-control-sm"
                            />
                        </div>
                        <div class="p-1 col-3 col-md-2">
                            <input
                                v-mask="'##'"
                                v-if="i === 0"
                                v-model.number="presented"
                                @keyup="updatePresented()"
                                class="form-control form-control-sm"
                                name="presented"
                            />
                        </div>
                        <div class="p-1 col-2 col-md-2 small">
                            {{
                                presented
                                    ? parseInt(
                                          (preferenceAssessmentItems[t].selected / presented) * 100
                                      )
                                    : "0"
                            }}%
                        </div>
                        <div class="p-1 col-2 col-md-3 p-0">
                            <input
                                v-model="note"
                                v-if="i === 0"
                                class="form-control form-control-sm"
                                name="note"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="goal.parameters.method === 'single'">
                <div class="col-9">
                    <div class="row" style="margin-top: -1.5rem;">
                        <div class="p-1 col-3 text-white text-uppercase small ellipsis">
                            Item
                        </div>
                        <div class="p-1 col-3 text-white text-uppercase small ellipsis">
                            Time
                        </div>
                        <div class="p-1 col-6 text-white text-uppercase small">
                            Note
                        </div>
                    </div>
                    <div class="row" v-for="(t, i) in goal.parameters.items">
                        <div class="p-1 col-3">
                            {{ t }}
                        </div>
                        <div class="p-1 col-3">
                            <input
                                v-mask="'##'"
                                type="text"
                                v-model.number="preferenceAssessmentItems[t].minutes"
                                name="task-success"
                                class="custom-input"
                                placeholder="min"
                                style="max-width: 2.6rem;"
                            />:
                            <input
                                v-mask="'##'"
                                type="text"
                                v-model.number="preferenceAssessmentItems[t].seconds"
                                @keyup="
                                    preferenceAssessmentItems[t].seconds > 59
                                        ? (preferenceAssessmentItems[t].seconds = 0)
                                        : null
                                "
                                name="task-success"
                                class="custom-input"
                                placeholder="sec"
                                style="max-width: 2.6rem;"
                            />
                        </div>
                        <div class="p-1 col-6">
                            <input
                                v-if="i === 0"
                                v-model="note"
                                class="form-control form-control-sm"
                                name="note"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="goal.parameters.method === 'mswo'">
                <div class="col-9">
                    <div class="row" style="margin-top: -1.5rem;">
                        <div class="p-1 col-3 text-white text-uppercase small ellipsis">
                            Item
                        </div>
                        <div class="p-1 col-3 text-white text-uppercase small ellipsis">
                            Points
                        </div>
                        <div class="p-1 col-6 text-white text-uppercase small">
                            Note
                        </div>
                    </div>
                    <div class="row" v-for="(t, i) in goal.parameters.items">
                        <div class="p-1 col-3">
                            {{ t }}
                        </div>
                        <div class="p-1 col-3">
                            <select
                                :value="preferenceAssessmentItems[t].points"
                                @input="setInput($event.target.value, i, t)"
                                name="task-success"
                                class="form-control form-control-sm"
                            >
                                <option value="" disabled hidden :value="null">Points</option>
                                <option :value="0">Not selected</option>
                                <option
                                    v-for="p in goal.parameters.items.length"
                                    :disabled="unavailablePointsInSequence.includes(parseInt(p))"
                                    :value="parseInt(p)"
                                    >{{ p }}</option
                                >
                            </select>
                        </div>
                        <div class="p-1 col-6">
                            <input
                                v-if="i === 0"
                                v-model="note"
                                class="form-control form-control-sm"
                                name="note"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="goal.parameters.method === 'msw'">
                <div class="col-9">
                    <div class="row" style="margin-top: -1.5rem;">
                        <div class="p-1 col-2 col-md-3 text-white text-uppercase small ellipsis">
                            Item
                        </div>
                        <div class="p-1 col-3 col-md-2 text-white text-uppercase small ellipsis">
                            Selected
                        </div>
                        <div class="p-1 col-3 col-md-2 text-white text-uppercase small ellipsis">
                            Presented
                        </div>
                        <div class="p-1 col-2 col-md-2 text-white text-uppercase small ellipsis">
                            Percent
                        </div>
                        <div class="p-1 col-3 col-md-3 text-white text-uppercase small">
                            Note
                        </div>
                    </div>
                    <div class="row" v-for="(t, i) in goal.parameters.items">
                        <div class="p-1 col-2 col-md-3">
                            {{ t }}
                        </div>
                        <div class="p-1 col-3 col-md-2">
                            <input
                                v-mask="'##'"
                                type="text"
                                v-model.number="preferenceAssessmentItems[t].selected"
                                @keyup="updateMswPresented()"
                                name="selected"
                                class="custom-input"
                                style="max-width: 3rem;"
                            />
                        </div>
                        <div class="p-1 col-2 col-md-2 ">
                            {{ mswPresented }}
                        </div>
                        <div class="p-1 col-2 col-md-2">
                            <small
                                >{{
                                    mswPresented
                                        ? parseInt(
                                              (preferenceAssessmentItems[t].selected /
                                                  mswPresented) *
                                                  100
                                          )
                                        : 0
                                }}%</small
                            >
                        </div>
                        <div class="col-3 col-md-3 p-0">
                            <input
                                v-if="i === 0"
                                v-model="note"
                                class="form-control form-control-sm"
                                name="note"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="goal.parameters.method === 'free_operant'">
                <div class="col-9">
                    <div class="row" style="margin-top: -1.5rem;">
                        <div class="p-1 col-3 text-white text-uppercase small ellipsis">
                            Item
                        </div>
                        <div class="p-1 col-3 text-white text-uppercase small ellipsis">
                            Times selected
                        </div>
                        <div class="p-1 col-3 text-white text-uppercase small ellipsis">
                            Time
                        </div>

                        <div class="p-1 col-2 text-white text-uppercase small">
                            Note
                        </div>
                    </div>
                    <div class="row" v-for="(t, i) in goal.parameters.items">
                        <div class="p-1 col-3">
                            {{ t }}
                        </div>
                        <div class="p-1 col-3">
                            <input
                                v-mask="'####'"
                                type="text"
                                v-model.number="preferenceAssessmentItems[t].selected"
                                name="task-success"
                                class="custom-input"
                                style="max-width: 3rem;"
                            />
                        </div>
                        <div class="p-1 col-3">
                            <input
                                v-mask="'##'"
                                type="text"
                                v-model.number="preferenceAssessmentItems[t].minutes"
                                name="task-success"
                                class="custom-input"
                                placeholder="min"
                                style="max-width: 2.6rem;"
                            />:
                            <input
                                v-mask="'##'"
                                type="text"
                                v-model.number="preferenceAssessmentItems[t].seconds"
                                @keyup="
                                    preferenceAssessmentItems[t].seconds > 59
                                        ? (preferenceAssessmentItems[t].seconds = 0)
                                        : null
                                "
                                name="task-success"
                                class="custom-input"
                                placeholder="sec"
                                style="max-width: 2.6rem;"
                            />
                        </div>
                        <div class="p-1 col-3">
                            <input
                                v-if="i === 0"
                                v-model="note"
                                class="form-control form-control-sm"
                                name="note"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <tracker-new-data-actions
                :saving="saving"
                :edit-target="editTarget"
                @save-data="submitData()"
                @edit-done="$emit('edit-done')"
            ></tracker-new-data-actions>
        </div>
    </div>
</template>

<script>
import { trackerNewDataCommon } from "./trackerNewDataCommon";

export default {
    name: "TrackerNewDataPreferenceAssessment",
    mixins: [trackerNewDataCommon],
    data() {
        return {
            columns: {
                titles: [`Date`, ``],
                col: [2, 9, 1],
            },
            date: new Date(),
            note: "",

            preferenceAssessmentItems: {},
            items: [],
            presented: 0,
            mswPresented: 0,
            mswoPoints: [],
        };
    },

    async mounted() {
        this.generatePreferenceAssessmentItems();

        this.items = this.goal.parameters.items;

        if (this.editTarget) {
            this.populateEdit();
        }
    },

    beforeDestroy() {
        this.resetComponent();
    },

    computed: {
        unavailablePointsInSequence() {
            let possiblePoints = Object.keys(this.preferenceAssessmentItems).map((k, i) => i + 1);
            return possiblePoints.filter(p => this.mswoPoints.includes(p));
        },
    },

    methods: {
        populateEdit() {
            let editTarget = { ...this.editTarget };
            this.date = editTarget.session_at;
            this.note = editTarget.notes;
            switch (editTarget.data.method) {
                case "single":
                    Object.keys(this.editTarget.data.items).forEach(k => {
                        this.preferenceAssessmentItems[k].duration = this.editTarget.data.items[
                            k
                        ].duration;
                        this.preferenceAssessmentItems[k].seconds =
                            this.editTarget.data.items[k].duration % 60;
                        this.preferenceAssessmentItems[k].minutes = Math.floor(
                            this.editTarget.data.items[k].duration / 60
                        );
                    });
                    break;
                case "free_operant":
                    //console.log(JSON.parse(JSON.stringify(this.editTarget.data.items)), JSON.parse(JSON.stringify(this.preferenceAssessmentItems)))
                    Object.keys(this.editTarget.data.items).forEach(k => {
                        if (!this.preferenceAssessmentItems.hasOwnProperty(k)) {
                            this.preferenceAssessmentItems[k] = {};
                        }
                        this.preferenceAssessmentItems[k].duration = this.editTarget.data.items[
                            k
                        ].duration;
                        this.preferenceAssessmentItems[k].seconds =
                            this.editTarget.data.items[k].duration % 60;
                        this.preferenceAssessmentItems[k].minutes = Math.floor(
                            this.editTarget.data.items[k].duration / 60
                        );
                        this.preferenceAssessmentItems[k].selected = this.editTarget.data.items[
                            k
                        ].selected;
                    });
                    break;
                case "mswo":
                    Object.keys(this.editTarget.data.items).forEach(k => {
                        this.preferenceAssessmentItems[k].points = this.editTarget.data.items[
                            k
                        ].points;
                    });
                    break;
                case "msw":
                    Object.keys(this.editTarget.data.items).forEach(k => {
                        this.preferenceAssessmentItems[k].presented = this.editTarget.data.items[
                            k
                        ].presented;
                        this.preferenceAssessmentItems[k].selected = this.editTarget.data.items[
                            k
                        ].selected;
                    });
                    this.updateMswPresented();
                    break;
            }
        },

        /*** PREFERENCE ASSESSMENT ***/

        setInput(val, idx, item) {
            this.$set(this.preferenceAssessmentItems, item, { points: parseInt(val) });
            this.$set(this.mswoPoints, idx, parseInt(val));
        },

        updatePresented() {
            this.goal.parameters.items.forEach(item => {
                this.preferenceAssessmentItems[item].presented = this.presented;
            });
        },

        updateMswPresented() {
            let presented = 0;
            Object.keys(this.preferenceAssessmentItems).forEach(k => {
                presented += this.preferenceAssessmentItems[k].selected;
            });
            this.goal.parameters.items.forEach(item => {
                this.preferenceAssessmentItems[item].presented = presented;
            });
            this.mswPresented = isNaN(presented) ? 0 : presented;
        },

        generatePreferenceAssessmentItems() {
            this.preferenceAssessmentItems = {};

            switch (this.goal.parameters.method) {
                case "single":
                    this.goal.parameters.items.forEach(item => {
                        this.preferenceAssessmentItems[item] = {
                            duration: 0,
                            seconds: null,
                            minutes: null,
                        };
                    });
                    break;
                case "paired":
                    this.goal.parameters.items.forEach(item => {
                        this.preferenceAssessmentItems[item] = {
                            presented: this.presented,
                            selected: 0,
                        };
                    });
                    break;
                case "free_operant":
                    this.goal.parameters.items.forEach(item => {
                        this.preferenceAssessmentItems[item] = {
                            duration: 0,
                            selected: 0,
                            seconds: null,
                            minutes: null,
                        };
                    });
                    break;
                case "mswo":
                    this.goal.parameters.items.forEach(item => {
                        this.mswoPoints.push(0);
                        this.preferenceAssessmentItems[item] = { points: 0 };
                    });
                    break;
                case "msw":
                    this.goal.parameters.items.forEach(item => {
                        this.preferenceAssessmentItems[item] = { presented: 0, selected: 0 };
                    });
                    break;
            }
        },

        resetPreferenceAssessmentItems() {
            if (this.goal.parameters.hasOwnProperty("items")) {
                this.goal.parameters.items.forEach(item => {
                    switch (this.goal.parameters.method) {
                        case "single":
                            this.preferenceAssessmentItems[item] = {
                                duration: 0,
                                minutes: null,
                                seconds: null,
                            };
                            break;
                        case "paired":
                            this.preferenceAssessmentItems[item] = { presented: 0, selected: 0 };
                            break;
                        case "free_operant":
                            this.preferenceAssessmentItems[item] = {
                                duration: 0,
                                selected: 0,
                                minutes: null,
                                seconds: null,
                            };
                            break;
                        case "mswo":
                            this.preferenceAssessmentItems[item] = { points: 0 };
                            break;
                        case "msw":
                            this.preferenceAssessmentItems[item] = { presented: 0, selected: 0 };
                            break;
                    }
                });
            }
        },

        submitData() {
            //Convert min:sec to seconds
            if (["free_operant", "single"].includes(this.goal.parameters.method)) {
                Object.keys(this.preferenceAssessmentItems).forEach(key => {
                    this.preferenceAssessmentItems[key].duration =
                        60 * this.preferenceAssessmentItems[key].minutes +
                        this.preferenceAssessmentItems[key].seconds;
                    delete this.preferenceAssessmentItems[key].minutes;
                    delete this.preferenceAssessmentItems[key].seconds;
                });
            }

            const payload = {
                data: {
                    type: "preference_assessment",
                    method: this.goal.parameters.method,
                    items: this.preferenceAssessmentItems,
                },
                notes: this.note,
                session_at: this.isoDate,
            };

            this.$emit("save-data", payload);
        },

        resetComponent() {
            this.date = new Date();
            this.note = "";
            this.resetPreferenceAssessmentItems();
        },
    },
};
</script>

<style scoped></style>
